<div class="container mt-4" dir="rtl" *ngIf="showGallery">
  <h3 class="mb-3">گالری تصاویر</h3>

  <div class="mb-4">
    <input type="text" [(ngModel)]="titleInput" placeholder="عنوان تصویر" class="form-control mb-2" />
    <input type="file" (change)="onFileSelected($event)" class="form-control mb-2" />
    <button class="btn btn-success" (click)="uploadImage()">آپلود تصویر</button>
  </div>

  <div class="row">
    <div class="col-md-4 mb-3" *ngFor="let img of images">
      <div class="card">
        <!-- <img [src]="img.imageUrl" class="card-img-top" alt="{{ img.title }}" style="height: 200px; object-fit: cover;" /> -->
        <!-- <img [src]="'https://cdick.ir/' + img.imageUrl" class="img-thumbnail" alt="{{ img.title }}"> -->
        <img [src]="'https://cdick.ir/' + img.imageUrl" class="img-thumbnail" alt="{{ img.title }}">

        <div class="card-body text-end">
          <h5 class="card-title">{{ img.title }}</h5>

          <!-- <div *ngIf="editingImage">
            <h5>ویرایش تصویر</h5>
            <form (submit)="updateImage()">
              <input [(ngModel)]="editingImage.title" name="title" class="form-control mb-2" placeholder="عنوان جدید">
              <input type="file" (change)="onFileSelected($event)" class="form-control mb-2">
              <button type="submit" class="btn btn-success">ذخیره تغییرات</button>
              <button type="button" class="btn btn-secondary" (click)="cancelEdit()">لغو</button>
            </form>
          </div> -->
          <div *ngIf="editingImage?.id === img.id">
            <h5>ویرایش تصویر</h5>
            <form (ngSubmit)="updateImage()">
              <input [(ngModel)]="editingImage.title" name="title" class="form-control mb-2" placeholder="عنوان جدید">
              <input type="file" (change)="onFileSelected($event)" class="form-control mb-2">
              <button type="submit" class="btn btn-success">ذخیره تغییرات</button>
              <button type="button" class="btn btn-secondary" (click)="cancelEdit()">لغو</button>
            </form>
          </div>


          <button class="btn btn-warning btn-sm" (click)="editImage(img)">ویرایش</button>

          <button class="btn btn-danger btn-sm" (click)="deleteImage(img.id)">حذف</button>
        </div>
      </div>
    </div>
  </div>
</div>
